<template>
  <div>
    <navigation />
    <topnav />
    <button id="toggle-tab" @click="toggleTab()">查看{{ tab == 0 ? '类别统计' : '标注员统计' }}</button>
    <div class="users-container">
      <table width="100%" class="table" v-if="tab == 0">
        <thead>
          <tr>
            <th>标注员</th>
            <th>标注图片总数</th>
            <th>有效图片数</th>
            <th>无效图片数</th>
            <th>标注框总数</th>
            <th>有效框数</th>
            <th>错误框数</th>
            <th>标注框准确率</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, index) of data" :key="`data${index}`">
            <td>{{ parseToZero(d.userName) }}</td>
            <td>{{ parseToZero(d.imgValid) + parseToZero(d.imgInvalid) }}</td>
            <td>{{ parseToZero(d.imgValid) }}</td>
            <td>{{ parseToZero(d.imgInvalid) }}</td>
            <td>{{ parseToZero(d.annoValid) + parseToZero(d.annoInvalid) }}</td>
            <td>{{ parseToZero(d.annoValid) }}</td>
            <td>{{ parseToZero(d.annoInvalid) }}</td>
            <td>
              {{
                ((parseToZero(d.annoValid) / (parseToZero(d.annoInvalid) + parseToZero(d.annoValid))) * 100).toFixed(2)
              }}%
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" class="table" v-if="tab == 1">
        <thead>
          <tr>
            <th v-for="c of classList" :key="`class${c.classId}`">{{ c.className }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="c of classList" :key="`class${c.classId}`">
              {{ classCount[c.classId] ? classCount[c.classId] : 0 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import topnav from '@/components/topnav';
import navigation from '@/components/navigation';

export default {
  data: function() {
    return {
      taskId: null,
      data: [],
      classList: [],
      classCount: [],
      tab: 0, // tab为0 显示标注员统计
    };
  },
  components: {
    topnav,
    navigation,
  },
  mounted: function() {
    api
      .getStatistics({ tid: [this.$route.query.tid] })
      .then(res => {
        const { annoValid, annoInvalid, imgValid, imgInvalid } = res.data;
        imgValid.forEach(i => {
          this.data.push({ userName: i.user_name, annotator: i.annotator, imgValid: parseInt(i.count) });
        });
        imgInvalid.forEach(i => {
          let tmp = this.data.find(v => v.annotator === i.annotator);
          if (tmp) {
            tmp.imgInvalid = parseInt(i.count);
          } else {
            this.data.push({ userName: i.user_name, annotator: i.annotator, imgInvalid: parseInt(i.count) });
          }
        });
        annoInvalid.forEach(i => {
          let tmp = this.data.find(v => v.annotator === i.annotator);
          if (tmp) {
            tmp.annoInvalid = parseInt(i.count);
          } else {
            this.data.push({ userName: i.user_name, annotator: i.annotator, annoInvalid: parseInt(i.count) });
          }
        });
        annoValid.forEach(i => {
          let tmp = this.data.find(v => v.annotator === i.annotator);
          if (tmp) {
            if (tmp.classes) {
              tmp.annoValid += parseInt(i.count);
              tmp.classes.push({ classId: i.class_ids, count: parseInt(i.count) });
            } else {
              tmp.annoValid = parseInt(i.count);
              tmp.classes = [{ classId: i.class_ids, count: parseInt(i.count) }];
            }
          } else {
            this.data.push({ userName: i.user_name, annotator: i.annotator, annoInvalid: parseInt(i.count) });
          }
        });
        this.data.sort((a, b) => {
          return a.annotator - b.annotator;
        });
        this.data.forEach(v => {
          if (v.classes) {
            v.classes.forEach(c => {
              if (this.classCount[c.classId]) {
                this.classCount[c.classId] += c.count;
              } else {
                this.classCount[c.classId] = c.count;
              }
            });
          }
        });
      })
      .catch(err => {
        window.console.log(err);
      });
    api
      .getClassInfo(this.$route.query.tid)
      .then(res => {
        this.classList = res.data.classifications[0].classes;
      })
      .catch(err => {
        window.console.log(err);
      });
  },
  methods: {
    getCount(classes, classId) {
      const c = classes.find(v => v.classId === classId);
      if (c) return c.count;
      return '';
    },
    parseToZero(v) {
      if (!v) return 0;
      return v;
    },
    toggleTab() {
      this.tab = 1 - this.tab;
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
  margin-top: 18px;
}
table th,
table td {
  padding-left: 24px;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
#toggle-tab {
  position: absolute;
  top: 70px;
  left: 298px;
  z-index: 999;
}
</style>
